<template>
	<el-upload :action="'#'" :http-request="onFileUpload" :accept="fileTypes == null ? '' : fileTypes.join(',')"
		:show-file-list="false" :disabled="disabled" :before-upload="beforeUpload" :multiple="true">
		<slot></slot>
	</el-upload>
</template>

<script>
export default {
	name: "fileUpload",
	data() {
		return {
			loading: null,
			uploadHeaders: {
				"accessToken": sessionStorage.getItem('accessToken')
			}
		}
	},
	props: {
		action: {
			type: String,
			required: false
		},
		fileTypes: {
			type: Array,
			default: null
		},
		maxSize: {
			type: Number,
			default: null
		},
		showLoading: {
			type: Boolean,
			default: false
		},
		isPermanent: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		onFileUpload(file) {
			// 展示加载条（带进度）
			if (this.showLoading) {
				this.loading = this.$loading({
					lock: true,
					text: '正在上传 0%',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			}
			let formData = new FormData()
			formData.append('file', file.file)
			let url = this.action;
			url += this.action.includes("?") ? "&" : "?"
			url += 'isPermanent=' + this.isPermanent;
			this.$http({
				url: url,
				data: formData,
				method: 'post',
				headers: {
					'Content-Type': 'multipart/form-data'
				},
				timeout: 1800000, // 30分钟超时，支持大文件上传
				onUploadProgress: (progressEvent) => {
					if (progressEvent.total > 0) {
						let percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
						if (this.loading) {
							this.loading.text = `正在上传 ${percent}%`;
						}
					}
				}
			}).then((data) => {
				this.$emit("success", data, file.file);
			}).catch((e) => {
				console.error("上传失败详情:", e);
				this.$emit("fail", e, file.file);
			}).finally(() => {
				this.loading && this.loading.close();
			})
		},
		getFileExtension(fileName) {
			if (!fileName || !fileName.includes('.')) return '';
			return fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
		},
		beforeUpload(file) {
			// 校验文件类型
			if (this.fileTypes && this.fileTypes.length > 0) {
				let fileType = file.type;
				let fileName = file.name;
				let ext = this.getFileExtension(fileName);
				// 同时支持 MIME type（如 image/jpeg）和文件扩展名（如 .doc）
				let matched = this.fileTypes.find((t) => {
					let tLower = t.toLowerCase();
					// 匹配 MIME type
					if (tLower === fileType) return true;
					// 匹配扩展名（支持 .doc 或 doc 格式）
					let tExt = tLower.startsWith('.') ? tLower.substring(1) : tLower;
					return tExt === ext;
				});
				if (matched === undefined) {
					// 生成友好的提示信息
					let typeNames = this.fileTypes.map(t => t.startsWith('.') ? t : '.' + t).join('、');
					this.$message.error(`不支持该文件类型，允许的格式：${typeNames}`);
					return false;
				}
			}
			// 校验大小
			if (this.maxSize && file.size > this.maxSize) {
				this.$message.error(`文件大小不能超过 ${this.fileSizeStr}!`);
				return false;
			}
			this.$emit("before", file);
			return true;
		}
	},
	computed: {
		fileSizeStr() {
			if (this.maxSize > 1024 * 1024) {
				return Math.round(this.maxSize / 1024 / 1024) + "M";
			}
			if (this.maxSize > 1024) {
				return Math.round(this.maxSize / 1024) + "KB";
			}
			return this.maxSize + "B";
		}
	}
}
</script>

<style></style>
